export enum Ownership {
  ORGANIZATION = 'Organization',
  GLOBAL = 'Global'
}

export const OrderedOwnershipLevels = [Ownership.ORGANIZATION, Ownership.GLOBAL];
